import {
  manageText,
  hide,
  base64E
} from './utils'
import {
  setText
} from './magnifier'
import speakConfig from '@/config'
let pointSpeakTimeId = null
let iframe_change = 0
/**
 * name: 无障碍阅读语速文本切换
 * param: 
 *     speedVal语速值
 */

function speedFont(speedVal) {
  if (speedVal > 0) {
    $(".wzatool_speakSpeed").each(function () {
      $(this).html("加快语速");
    });
  } else if (speedVal == 0) {
    $(".wzatool_speakSpeed").each(function () {
      $(this).html("正常语速");
    });
  } else if (speedVal < 0) {
    $(".wzatool_speakSpeed").each(function () {
      $(this).html("减缓语速");
    });
  }
}

// 调节声音大小
export function speakSpeed(s, store) {
  const {
    commit,
    state
  } = store
  if (state.speak.statusbatchRead == "off" || state.speak.statuspointread == "off") {
    if (s == 1) {
      if (state.speak.speedVal < 1) {
        commit('setSpeedVal', state.speak.speedVal + 1)
      }
    } else if (s == -1) {
      if (state.speak.speedVal > -1) {
        commit('setSpeedVal', state.speak.speedVal - 1)
      }
    }
    speedFont(state.speak.speedVal);
  }
  //speak.speedVal=s;
};
// 开关声音
export function wzaToolSpeakOnOff(store) {
  const {
    commit,
    state
  } = store
  if (state.speak.statusSpeakOnOff == "on") {
    $("#wzatool_speakOnOff").find("img").attr("src", "../../../static/img/wza/icon/dis_sound.png");
    $("#wzatool_batchRead").find("img").attr("src", "../../../static/img/wza/icon/continuous.png");
    $("#wzatool_Pointread").find("img").attr("src", "../../../static/img/wza/icon/point.png");
    // $("#wzatool_playSpeech").attr("onclick", "hide('cy_playSpeech_dl')");
    commit('setStatusSpeakOnOff', "off")
    commit('setStatusbatchRead', "off")
    automateSpeakClose(store);
    commit('setStatuspointread', "off")
    closePointSpeak(store);
  } else if (state.speak.statusSpeakOnOff == "off") {
    $("#wzatool_speakOnOff").find("img").attr("src", "../../../static/img/wza/icon/sound.png");
    $("#wzatool_batchRead").find("img").attr("src", "../../../static/img/wza/icon/continuous_stop.png");
    // if (state.speak.statusbatchRead == "off") {
    // 	$("#wzatool_batchRead").removeClass("batchReadOn");
    // 	automateSpeakClose(store);
    // 	commit('setStatusbatchRead', "on")
    // }
    $("#wzatool_Pointread").find("img").attr("src", "../../../static/img/wza/icon/cursor.png");
    if (state.speak.statuspointread == "off") {
      $("#wzatool_Pointread").removeClass("PointreadOn");
      startPointSpeak(undefined, store);
      commit('setStatuspointread', "on")
    }
    $("#wzatool_playSpeech").removeAttr("onclick");
    if (document.getElementById("cy_playSpeech_dl").className == "xian_1") {
      hide("cy_playSpeech_dl");
    }
    commit('setSpeedVal', 0)
    commit('setIndex', 0)
    commit('setAutoSpeakObj', null)
    commit('setSource', [])
    $(".wzatool_speakSpeed").each(function () {
      $(this).html("语速调节");
    });
    commit('setStatusSpeakOnOff', 'on')
    sendText2Cloud()
  }
};

//点读与键盘朗读调用sound
function callSM2(GuTarget, store) {
  const {
    commit,
    state
  } = store
  var text = "";
  text = manageText(GuTarget);
  //为鼠标指中，并有文本内容的元素更换背景色，（还原）speakFousOn
  if (state.speak.thisdom != null && (state.speak.thisdom.innerHTML.replace(/<.+?>/g, '').replace(/\s/g, '').length > 0 || (state.speak.thisdom.tagName == "INPUT" && state.speak.thisdom.type != "hidden"))) {
    //恢复之前选第一句只变黑第一句不是一段变黑  放开了上方if的注释
    if (state.speak.thisdom_type == "css") {
      $(state.speak.thisdom).css("background-color", "");
      $(state.speak.thisdom).css("color", "");
    }
    if (state.speak.thisdom_type == "style") {
      $(state.speak.thisdom).css("background-color", state.speak.thisdom_back);
      $(state.speak.thisdom).css("color", "");
    }
  };
  commit('setThisdom', GuTarget) //恢复之前选第一句只变黑第一句不是一段变黑  添加这句和注释了下面一段
  //为鼠标指中，并有文本内容的元素更换背景色，（变为蓝色）
  if (state.speak.thisdom.innerHTML.replace(/<.+?>/g, '').replace(/\s/g, '').length > 0 || (state.speak.thisdom.tagName == "INPUT" && state.speak.thisdom.type != "hidden")) {
    //恢复之前选第一句只变黑第一句不是一段变黑  放开了上方if的注释
    var style = $(state.speak.thisdom).attr("style");
    if (style == undefined) {
      commit('setThisdomType', "css")
    } else {
      var splits = style.split(";");
      if (splits.length > 0) {
        for (var i = 0; i < splits.length; i++) {
          var c = splits[i].split(":");
          if (c.length > 0 && c[0].indexOf("color") > -1) {
            commit('setThisdomType', "style")
            commit('setThisdomFont', $(state.speak.thisdom).css("color"))
            commit('setThisdomBack', $(state.speak.thisdom).css("background-color"))
          } else {
            commit('setThisdomType', "css")
          }
        }
      }
    }
    $(state.speak.thisdom).css("background-color", "black");
    $(state.speak.thisdom).css("color", "white");
  }

  if (text.replace(/[ ]/g, "").length == 0) {
    return;
  }
  //设置同步屏幕
  setText(text);
  audioSpeak(state.speak.speedVal, text);
  // var de= base64E(text);
  // $.ajax({
  // 	type:'GET',
  // 	url:speakConfig.speakConfig.ajaxUrl,
  // 	dataType:'jsonp',
  // 	jsonp:"callback",
  // 	data:{"b":de,"s":state.speak.speedVal},
  // 	async: true,
  // 	success:function(data){
  // 		console.log("data:" + data);
  // 		if(state.speak.mp3Object!=null){
  // 			state.speak.mp3Object.destruct();
  // 		}
  // 		commit('setMp3Object', soundManager.createSound({
  // 			id:'tool',
  // 			url:data.u,
  // 				onload:function(l){
  // 					if(l==0){
  // 						if(mp3Object!=null){
  // 							mp3Object.destruct();
  // 						}
  // 					}

  // 			}
  // 		}))
  // 		state.speak.mp3Object.play();
  // 	},
  // 	error: function(e){
  // 		console.log(e);
  // 	}
  // });

};

function audioSpeak(spd, text) {
  var ttsDiv = document.getElementById('wzaAudioDiv');
  var ttsAudio = document.getElementById('wzaAudio');
  ttsDiv.removeChild(ttsAudio);
  
  var baiduUrl = speakConfig.speakConfig.baidUrl + "spd=" + 6 + "&word=" + text+"&le=zh&keyfrom=speaker-target";
  var audio1 = '<audio class="audio" id="wzaAudio" controls autoplay="autoplay">';
  var source = '<source id="wzaAudioSource" src=' + baiduUrl + ' type="audio/mpeg">';
  var embed = '<embed height="0" width="0" src="">';
  var audio2 = '</audio>';
  ttsDiv.innerHTML = audio1 + source + embed + audio2;
  ttsAudio = document.getElementById('wzaAudio');
  ttsAudio.play();
}


/**
 * name: 无障碍阅读指读打开
 * param: 
 *     GuTarget 指读文字
 *     store speak共享状态  
 */
export function startPointSpeak(GuTarget, store) {
  let {
    commit,
    state
  } = store
  iframe_change = state.speak.iframe_change
  //切换文本正常语速
  speedFont(0)
  // 修改 指读状态
  commit('setSpeakerStatus', true)
  if (state.speak.automateSpeakStatus) {
    $('#wzatool_batchRead').trigger('click')
    commit('setThisDom', null)
  } else if (state.speak.keybordSpeakStatus) {
    $('#wzaTool_keybordRead').trigger('click')
    commit('setThisDom', null)
  }
  //重复检测， 如果鼠标移动时在同一个元素上则不触发以后方法
  if (state.speak.thisdom !== null && state.speak.thisdom === GuTarget) {
    return;
  }

  $('#mainBody').find(".wzaToolTextCon").each(function () {
    $(this).unbind("mouseover.pSpeak").unbind("mouseout.pSpeak");
    $(this).unbind("focus.fSpeak").unbind("blur.fSpeak");
  });
  $('#mainBody').find(".wzaToolTextCon").each(function () {
    var psObj = $(this);
    psObj.bind("mouseover.pSpeak", function () {
      pointSpeakTimeId = setTimeout(function () {
        callSM2(psObj[0], store);
      }, 500);

    });
    psObj.bind("mouseout.pSpeak", function () {
      window.clearTimeout(pointSpeakTimeId);
    });
    psObj.bind("focus.fSpeak", function () {
      pointSpeakTimeId = setTimeout(function () {
        callSM2(psObj[0], store);
      }, 500);

    });
    psObj.bind("blur.fSpeak", function () {
      window.clearTimeout(pointSpeakTimeId);
    });
  });
}

// function startPointSpeak(){}


/**
 * name: 无障碍阅读指读关闭
 * param: 
 *     store speak共享状态  
 */
function closePointSpeak(store) {
  let {
    commit,
    state
  } = store
  clearTimeout(pointSpeakTimeId)
  if (state.speak.mp3Object !== null) {
    state.speak.mp3Object.destruct()
  }
  commit('setSpeakerStatus', false)
  // 当鼠标指中并有文本内容的元素更换背景色， 还原speakFocusOn
  if (state.speak.iframe_change == iframe_change) {
    if (state.speak.thisdom_type == "css") {
      $(state.speak.thisdom).css("background-color", "");
      $(state.speak.thisdom).css("color", "");
    }
    if (state.speak.thisdom_type == "style") {
      $(state.speak.thisdom).css("background-color", state.speak.thisdom_back);
      $(state.speak.thisdom).css("color", "");
    }
  }
  commit('setThisdomType', null)
  commit('setThisdom', null)
  commit('setThisdomBack', null)

  $('#mainBody').find(".wzaToolTextCon").each(function () {
    $(this).unbind("mouseover.pSpeak").unbind("mouseout.pSpeak");
    $(this).unbind("focus.fSpeak").unbind("blur.fSpeak");
  });
}

/**
 * name: 无障碍阅读图片切换
 * param: 
 *     store
 */
export function wzaToolPointread(store, statuspointread) {
//   debugger
  const {
    commit
  } = store
  if (statuspointread === 'on') {
    $('#wzatool_Pointread').find('img').attr('src', '../../../static/img/wza/icon/point.png')
    $('#wzatool_Pointread').addClass('PointreadOn')
    // 更改连读状态
    commit('setStatusbatchRead', 'off')
    //修改连读图标
    $("#wzatool_batchRead").find('img').attr('src', "../../../static/img/wza/icon/continuous_start.png")
    $('#wzatool_batchRead').addClass('batchReadOn')
    // 开启只读
    startPointSpeak(undefined, store)
    commit('setStatuspointread', 'off')
  }
  else {
  	$('#wzatool_Pointread').find('img').attr('src', '../../../static/img/wza/icon/point.png')
  	$('#wzatool_Pointread').removeClass('PointreadOn')
  	// 关闭只读
  	closePointSpeak(store)
  	//打开连续图标
  	// 更改连读状态
  	commit('setStatusbatchRead', 'on')
  	//修改连读图标
  	$("#wzatool_batchRead").find('img').attr('src', "../../../static/img/wza/icon/continuous_stop.png")
  	$('#wzatool_batchRead').removeClass('batchReadOn')
  	//开启连读
  	// automateSpeak(store)
  	commit('setStatuspointread', 'on')
  }
  sendText2Cloud()
}

/**
 * name: 无障碍阅读连续阅读图片切换
 * param: 
 *     store
 */

export function wzaToolBatchRead(store) {
  // debugger

  const {
    commit,
    state
  } = store
  if (state.speak.statusbatchRead === 'on') {
    $("#wzatool_batchRead").find('img').attr('src', "../../../static/img/wza/icon/continuous_start.png")
    $('#wzatool_batchRead').addClass('batchReadOn')
    // 更改指读状态
    commit('setStatuspointread', 'on')
    // 启动只读
    startPointSpeak(undefined, store)
    $('#wzatool_Pointread').addClass('PointreadOn')
    // automateSpeakClose(store)
    // commit('setStatusbatchRead', 'off')
  }
  //  else if (state.speak.statusbatchRead === 'off') {
  // 	$("#wzatool_batchRead").find('img').attr('src', "../../../static/img/wza/icon/continuous_stop.png")
  // 	$('#wzatool_batchRead').removeClass('batchReadOn')
  // 	// 更改指读状态
  // 	commit('setStatuspointread', 'off')
  // 	// 关闭只读
  // 	closePointSpeak(store)
  // 	$('#wzatool_Pointread').removeClass('PointreadOn')
  // 	// commit('setAutomateSpeakStatus', false)
  // 	//开启连读
  // 	// automateSpeak(store)
  // 	// commit('setStatusbatchRead', 'on')
  // }
  sendText2Cloud()

}

/**
 * name: 无障碍阅读开启自动朗读
 * param: 
 *     store
 */

function automateSpeak(store) {
  const {
    commit,
    state
  } = store
  if (state.speak.speakerStatus) { //如果开启指读,则关闭 指读.
    $("#wzaTool_Pointread").trigger("click");
    commit('setThisdomPoint', null)
  }
  if (state.speak.keybordSpeakStatus) { //如果开启键盘朗读则关闭
    $("#wzaTool_keybordRead").trigger("click");
    commit('setThisdomKB', null)
  }

  $('#mainBody').find(".wzaToolTextCon").each(function () {
    $(this).unbind("mouseover.pSpeak").unbind("mouseout.pSpeak");
  });

  $('#mainBody').find(".wzaToolTextCon").each(function () {
    var psObj = $(this);
    psObj.bind("mouseover.pSpeak", function () {
      pointSpeakTimeId = setTimeout(function () {
        automateSpeakClose(store);
        automateSpeak1(store, psObj[0]);
      }, 1000);

    });
    psObj.bind("mouseout.pSpeak", function () {
      window.clearTimeout(pointSpeakTimeId);
    });
  });
}

/**
 * name: 无障碍阅读自动朗读
 * param: 
 *     store
 */
function automateSpeak1(store, t) {
  let {
    commit,
    state
  } = store
  iframe_change = state.speak.iframe_change;
  speedFont(0);
  commit('setAutomateSpeakStatus', true)

  if (state.speak.autoSpeakObj !== null) {
    state.speak.autoSpeakObj.destruct();
  }

  if (state.speak.speakerStatus) { //如果开启指读,则关闭 指读.
    $("#wzaTool_Pointread").trigger("click");
    commit('setThisdomPoint', null)
  }
  if (state.speak.keybordSpeakStatus) { //如果开启键盘朗读则关闭
    $("#wzaTool_keybordRead").trigger("click");
    commit('setThisdomKB', null)
  }
  if (state.speak.index === 0 || state.speak.index < state.speak.source.length) {
    //如果数组中没有内容 ，则向里添加页面所有对象
    if (state.speak.source.length === 0) {
      $('#mainBody').find(".wzaToolTextCon").each(function () {
        state.speak.source.push(this);
      });
    }
    if (t != undefined) {
      for (var j = 0; j < state.speak.source.length; j++) {
        if (state.speak.source[j] == t) {
          commit('setIndex', j);
        }
      }
    }
    commit('setThisdomAuto', state.speak.source[state.speak.index])
    var parent = $(state.speak.thisdomAuto).parent();
    var tagName = $(parent).get(0).tagName;
    if (tagName == 'P' || tagName == 'DIV' || tagName == 'SPAN' || tagName == 'INS') {
      var tab1 = $(state.speak.thisdomAutoParent).find(".wzaToolTextCon:first").attr("tabIndex");
      var tab2 = $(parent).find(".wzaToolTextCon:first").attr("tabIndex");
      if (tab1 != tab2) {
        $(state.speak.thisdomAutoParent).css("background-color", state.speak.thisdomAutoParent_back);
        commit('setThisdomAutoParentBack', $(parent).css("background-color"))
        $(parent).css("background-color", "#CCC");
        commit('setThisdomAutoParent', parent)
      }
    } else {
      $(state.speak.thisdomAutoParent).css("background-color", state.speak.thisdomAutoParent_back);
    }
    var text = manageText(state.speak.thisdomAuto);
    //设置同步屏幕
    setText(text);
    //如果转换后内容为空，则不朗读,进行下一个内容。
    if (text.length == 0) {
      commit('setIndex', ++state.speak.index)
      automateSpeak1(store);
      return;
    }
    $(state.speak.thisdomAuto).focus();
    if (state.speak.thisdomAuto.innerHTML.replace(/<.+?>/g, '').replace(/\s/g, '').length > 0) {
      //取出保存样式
      var style = $(state.speak.thisdomAuto).attr("style");
      if (style == undefined) {
        commit('setThisdomAutoType', 'css')
      } else {
        var splits = style.split(";");
        if (splits.length > 0) {
          for (var i = 0; i < splits.length; i++) {
            var c = splits[i].split(":");
            if (c.length > 0 && c[0].indexOf("color") > -1) {
              commit('setThisdomAutoType', 'style')
              commit('setThisdomAutoBack', $(state.speak.thisdomAuto).css("background-color"))
              commit('setThisdomAutoFont', $(state.speak.thisdomAuto).css("color"))
            } else {
              commit('setThisdomType', 'css')
            }
          }
        }
      }
      //设置样式
      $(state.speak.thisdomAuto).css("background-color", "black");
      $(state.speak.thisdomAuto).css("color", "white");
    }
    audioSpeak(state.speak.speedVal, text);
    // var de= base64E(text);
    // $.ajax({
    // 	type:'GET',
    // 	url:speakConfig.speakConfig.ajaxUrl,
    // 	dataType:'jsonp',
    // 	jsonp:"callback",
    // 	data:{"b":de,"s":state.speak.speedVal},
    // 	async: true,
    // 	success:function(data){
    // 		if(state.speak.automateSpeakStatus==false){
    // 			return;
    // 		}
    // 		commit('setAutoSpeakObj', soundManager.createSound({
    // 			id:'tool',
    // 			url:data.u,
    // 			onload: function(bSuccess) {
    // 				if(!bSuccess){
    // 					automateSpeak(store);
    // 				}
    // 				//soundManager._writeDebug('sound '+(bSuccess?'loaded!': 'did NOT load.'));
    // 			},
    // 			onfinish:function(){
    // 				state.speak.autoSpeakObj.destruct();
    // 				commit('setAutoSpeakObj', null)
    // 				//还原样式
    // 				if(state.speak.thisdomAuto_type=="css"){
    // 					$(state.speak.thisdomAuto).css("background-color","");
    // 					$(state.speak.thisdomAuto).css("color","");
    // 				}
    // 				if(state.speak.thisdomAuto_type=="style"){
    // 					$(state.speak.thisdomAuto).css("background-color", state.speak.thisdomAuto_back);
    // 					$(state.speak.thisdomAuto).css("color","");
    // 				}
    // 				commit('setIndex', ++state.speak.index)
    // 				automateSpeak1(store);
    // 			},
    // 			onload:function(l){
    // 				  if(l==0){
    // 					state.speak.autoSpeakObj.destruct();
    // 				    commit('setAutoSpeakObj', null)
    // 						//还原样式
    // 						if(state.speak.thisdomAuto_type=="css"){
    // 							$(state.speak.thisdomAuto).css("background-color","");
    // 							$(state.speak.thisdomAuto).css("color","");
    // 						}
    // 						if(state.speak.thisdomAuto_type=="style"){
    // 							$(state.speak.thisdomAuto).css("background-color", state.speak.thisdomAuto_back);
    // 							$(state.speak.thisdomAuto).css("color","");
    // 						}
    // 						commit('setIndex', ++state.speak.index)
    // 						automateSpeak1(store);
    // 				  }

    // 			}
    // 		}))
    // 		state.speak.autoSpeakObj.play();
    // 	}
    // });
    // state.speak.autoSpeakObj.destruct();
    commit('setAutoSpeakObj', null)
    //还原样式
    if (state.speak.thisdomAuto_type == "css") {
      $(state.speak.thisdomAuto).css("background-color", "");
      $(state.speak.thisdomAuto).css("color", "");
    }
    if (state.speak.thisdomAuto_type == "style") {
      $(state.speak.thisdomAuto).css("background-color", state.speak.thisdomAuto_back);
      $(state.speak.thisdomAuto).css("color", "");
    }
    commit('setIndex', ++state.speak.index)
    automateSpeak1(store);
  } else { //如果读完全文，则关闭全文朗读，并清空thisdom
    commit('setIndex', 0)
    return;
  }
}


/**
 * name: 无障碍阅读关闭自动朗读
 * param: 
 *     store
 */
function automateSpeakClose(store) {
  const {
    commit,
    state
  } = store
  commit('setAutomateSpeakStatus', false)
  if (state.speak.autoSpeakObj !== null) {
    state.speak.autoSpeakObj.destruct();
  }
  commit('seSource', []);
  commit('setIndex', 0)
  if (state.speak.iframe_change == iframe_change) {
    //还原样式
    if (state.speak.thisdomAuto_type == "css") {
      $(state.speak.thisdomAuto).css("background-color", "");
      $(state.speak.thisdomAuto).css("color", "");
    }
    if (state.speak.hisdomAuto_type == "style") {
      $(state.speak.thisdomAuto).css("background-color", state.speak.thisdomAuto_back);
      $(state.speak.thisdomAuto).css("color", "");
    }
  }
  commit('setThisdomAuto', null)
  commit('setThisdomAutoBack', null)
  commit('setThisdomAutoFont', null)
  //连读每次鼠标移动后重新指定时 都会调用speak.sound.automateSpeakClose
  //只有当statusbatchRead=="on"时，也就是点击了连读关闭才可以清除mouseover事件否则无法重新指定连读内容
  if (state.speak.statusbatchRead == "on") {
    $('#mainBody').find(".wzaToolTextCon").each(function () {
      $(this).unbind("mouseover.pSpeak").unbind("mouseout.pSpeak");
    });
  }
}
//需要所有函数执行完 执行这个函数添加类名
export function sendText2Cloud() {
  // debugger
  var arr = new Array();
  var i = 1;
  $('#mainBody').find("*:not(.displayClass)").each(function (index) {
    var obj = $(this);
    var text = "";
    text = manageText(obj[0]);
    if (text != null && text != "") {
      obj.attr("tabindex", i).addClass('wzaToolTextCon'); //为每个带有文本节点的dom增加属性Tabindex，并且增加class属性ESDAssetsTextCon
      i++;
      // var de = base64E(text);
      arr.push(text);
      // for (var j=0; j<arr.length; j++) {
      // 	var ttsAudio = document.getElementById('wzaAudio');
      // 	var sleepTime = ttsAudio.duration;
      // 	if(sleepTime > 0){
      // 		sleep(sleepTime, () => {
      // 			console.log("sleepTime1" + sleepTime);
      // 		})
      // 	}
      // 	// audioSpeak(2, arr[0]);
      // }
      // var ttsAudio = document.getElementById('wzaAudio');
      // var sleepTime = 1000;
      // if(sleepTime > 0){
      // 	sleep(sleepTime, () => {
      // 		console.log("sleepTime1" + sleepTime);
      // 	})
      // }
      // audioSpeak(2, text);
      // arr = new Array();
      //保正不能超过5句,每句不能超过100字
      // if(arr.length>5){
      // 	$.ajax({
      // 		type:'GET',
      // 		url:speakConfig.speakConfig.batchUrl,
      // 		dataType:'jsonp',
      // 		jsonp:"callback",
      // 		data:{"b":arr,"s":"0"},
      // 		async: true
      // 	});
      // 	$.ajax({
      // 		type:'GET',
      // 		url:speakConfig.speakConfig.batchUrl,
      // 		dataType:'jsonp',
      // 		jsonp:"callback",
      // 		data:{"b":arr,"s":"1"},
      // 		async: true
      // 	});
      // 	$.ajax({
      // 		type:'GET',
      // 		url:speakConfig.speakConfig.batchUrl,
      // 		dataType:'jsonp',
      // 		jsonp:"callback",
      // 		data:{"b":arr,"s":"-1"},
      // 		async: true
      // 	});
      // 	//清空缓存
      // 	arr = new Array();
      // }				
    }
  });

  $("*:not(.displayClass)").each(function (index) {
    var obj = $(this);
    var text = "";
    text = manageText(obj[0]);
    if (text != null && text != "") {
      obj.addClass("wzaToolTextCon"); //为每个带有文本节点的dom增加属性Tabindex，并且增加class属性ESDAssetsTextCon
      i++;
      // var de = base64E(text);
      // arr.push(text);
      // for (var j=0; j<arr.length; j++) {
      // 	var ttsAudio = document.getElementById('wzaAudio');
      // 	// audioSpeak(2, arr[0]);
      // }
      // var sleepTime = 1000;
      // if(sleepTime > 0){
      // 	sleep(sleepTime, () => {
      // 		console.log("sleepTime2" + sleepTime);
      // 	})
      // }
      // audioSpeak(2, text);
      // arr = new Array();
      //保正不能超过5句,每句不能超过100字
      // if(arr.length>5){
      // 	$.ajax({
      // 	    type:'GET',
      // 	    url:speakConfig.speakConfig.batchUrl,
      // 	    dataType:'jsonp',
      // 	    jsonp:"callback",
      // 	    data:{"b":arr,"s":"0"},
      // 	    async: true
      // 	});
      // 	$.ajax({
      // 		type:'GET',
      // 		url:speakConfig.speakConfig.batchUrl,
      // 		dataType:'jsonp',
      // 		jsonp:"callback",
      // 		data:{"b":arr,"s":"1"},
      // 		async: true
      // 	});
      // 	$.ajax({
      // 		type:'GET',
      // 		url:speakConfig.speakConfig.batchUrl,
      // 		dataType:'jsonp',
      // 		jsonp:"callback",
      // 		data:{"b":arr,"s":"-1"},
      // 		async: true
      // 	});
      // 	//清空缓存
      //  	arr = new Array();
      // }
    }
  });

  if (arr.length > 0) {
    // $.ajax({
    //     type:'GET',
    //     url:speakConfig.speakConfig.batchUrl,
    //     dataType:'jsonp',
    //     jsonp:"callback",
    //     data:{"b":arr,"s":"0"},
    //     async: true
    // });
    // $.ajax({
    // 	type:'GET',
    // 	url:speakConfig.speakConfig.batchUrl,
    // 	dataType:'jsonp',
    // 	jsonp:"callback",
    // 	data:{"b":arr,"s":"1"},
    // 	async: true
    // });
    // $.ajax({
    // 	type:'GET',
    // 	url:speakConfig.speakConfig.batchUrl,
    // 	dataType:'jsonp',
    // 	jsonp:"callback",
    // 	data:{"b":arr,"s":"-1"},
    // 	async: true
    // });
  };
  arr = new Array();
}

function sleep(ms, callback) {
  setTimeout(callback, ms);
}

//语音提示
function voicePromptPlay(store, voiceId, voiceUrl) {
  const {
    commit,
    state
  } = store
  if (state.speak.voicePromptObject != null) {
    voicePromptObject.destruct();
  }
  commit('setVoicePromptObject', soundManager.createSound({
    id: voiceId,
    url: voiceUrl,
    onfinish: function () {
      voicePromptObject.destruct();
    }
  }))
  state.speak.voicePromptObject.play();
};

//播放提示Shift+z
export function soundVoicePromptShiftz(store) {
  var id = "prompt_shift2";
  var url = speakConfig.speakConfig.shift2;
  // voicePromptPlay(store,id,url);
};

//隐藏语音调节
export function hideSpeech(store) {
  const {
    commit,
    state
  } = store
  if (state.speak.statusSpeakOnOff == "off") {
    return;
  }
  if (document.getElementById('cy_playSpeech_dl').className == "yin_1") {
    $(".wzatool_main_table ul li dl.xian_1").removeClass("xian_1").addClass("yin_1");
    document.getElementById('cy_playSpeech_dl').className = "xian_1";
  } else {
    $(".wzatool_main_table ul li dl.xian_1").removeClass("xian_1").addClass("yin_1");
  }
}



// WEBPACK FOOTER //
// ./src/assets/wza/js/speak.js